import utils from "./utils";

// 类型定义
interface ConfigType {
  requestTimeout: number;
  onUser: ((user: any) => void) | null;
  onRequireLogin: (() => void) | null;
  onCloseLogin: (() => void) | null;
  onRequireRegister: (() => void) | null;
  toggleRechargeNotice:
    | ((show: boolean, type?: number | null, message?: string) => void)
    | null;
  onToggleRecharge: ((show: boolean, type: number) => void) | null;
  defaultBetAmount: number;
  defaultVisitorName: string;
  onToggleMessage: ((show: boolean) => void) | null;
  localTime: number;
  onToggleUpdate: (() => void) | null;
  onToggleChat: (() => void) | null;
  symbol: string;
  symbolText: string;
  useGameSymbol: boolean;
  setActionKey: ((key: string, value: any) => void) | null;
  actionKeyHandlers: Record<string, any>;
  onToggleGoogleAuth: ((show: boolean, type: number) => void) | null;
  onScratchGame: (() => void) | null;
  onToggleForbidden: ((show: boolean, resp: any) => void) | null;
  onSignPopup: ((show: boolean) => void) | null;
  getLoadingIcon: () => string | null;
  getGlobalLoadIcon: () => string | null;
  getIcon: () => string | null;
  getPcIcon: () => string | null;
  getImageCdnRoot: () => string | undefined;
  getWssCdnRoot: () => string;
  getWssCdnRootWithoutPath: () => string;
  getApiCdnRoot: () => string | undefined;
  getAssetUrl: (path: string) => string;
  getOnOpen: (name: string) => (() => void) | undefined;
  setOnOpen: (name: string, fn: () => void) => void;
  getGlobalVar: (name: string) => any;
  setGlobalVar: (name: string, value: any) => void;
  init: () => void;
  storeSessionKey?: string;
  onReplaceUrl?: (url: string) => string;
  onAppendHeaders?: (headers: Record<string, string>) => void;
  _ignoreErrorPathList?: Array<string | RegExp>;
}

const config: ConfigType = {
  requestTimeout: 60000,
  onUser: null,
  onRequireLogin: null,
  onCloseLogin: null,
  onRequireRegister: null,
  toggleRechargeNotice: null,
  onToggleRecharge: null,
  defaultBetAmount: 5,
  defaultVisitorName: "NewVisitor",
  onToggleMessage: null,
  localTime: 0,
  onToggleUpdate: null,
  onToggleChat: null,
  symbol: "$",
  symbolText: "$",
  useGameSymbol: true,
  setActionKey: null,
  actionKeyHandlers: {},
  onToggleGoogleAuth: null,
  onScratchGame: null,
  onToggleForbidden: null,
  onSignPopup: null,
  getLoadingIcon(): string | null {
    const icon = (window as any)._config && (window as any)._config.loadingIcon;
    if (icon) {
      return utils.getImageUrl(icon);
    }
    return this.getGlobalLoadIcon();
  },
  getGlobalLoadIcon(): string | null {
    const icon =
      (window as any)._config && (window as any)._config.globalLoadIcon;
    if (icon) {
      return utils.getImageUrl(icon);
    }
    return this.getIcon();
  },
  getIcon(): string | null {
    const icon = (window as any)._config && (window as any)._config.icon;
    if (icon) {
      return utils.getImageUrl(icon);
    }
    return "";
  },
  getPcIcon(): string | null {
    const icon = (window as any)._config && (window as any)._config.pcIcon;
    if (icon) {
      return utils.getImageUrl(icon);
    }
    return this.getIcon();
  },
  getImageCdnRoot(): string | undefined {
    const ret = (window as any)._config && (window as any)._config.imageCdnRoot;
    return ret;
  },
  getWssCdnRoot(): string {
    const ret = (window as any)._config && (window as any)._config.wssCdnRoot;
    if (ret) return ret;
    const proto = window.location.protocol === "https:" ? "wss" : "ws";
    return proto + "://" + window.location.host;
  },
  getWssCdnRootWithoutPath(): string {
    const ret = this.getWssCdnRoot();
    const i = ret.indexOf("/", 10);
    if (i > 0) {
      return ret.substring(0, i);
    } else {
      return ret;
    }
  },
  getApiCdnRoot(): string | undefined {
    const ret = (window as any)._config && (window as any)._config.apiCdnRoot;
    return ret;
  },
  getAssetUrl(path: string): string {
    if (path.indexOf("/") !== 0) {
      return path;
    }
    if (path.indexOf("/assets/") !== 0) {
      path = "/assets" + path;
    }
    const imgCdn = this.getImageCdnRoot();
    if (!imgCdn) return path;
    return imgCdn + path;
  },
  getOnOpen(name: string): (() => void) | undefined {
    if (!name) return;
    if (!utils.hasProperty(onOpenList, name)) return;
    if (onOpenList[name] === null) return;
    return onOpenList[name];
  },
  setOnOpen(name: string, fn: () => void): void {
    if (!name || !fn) return;
    if (!utils.hasProperty(onOpenList, name)) return;
    onOpenList[name] = fn;
  },
  getGlobalVar(name: string): any {
    if (!utils.hasProperty(globalVars, name)) return;
    return globalVars[name];
  },
  setGlobalVar(name: string, value: any): void {
    globalVars[name] = value;
  },
  init() {},
};
window.deferredPromptPrompt = function () {
  if (!window.deferredPrompt) return;
  window.deferredPrompt.prompt();
  window.deferredPrompt.userChoice.then((choiceResult: any) => {
    if (choiceResult.outcome === "accepted") {
      // 用户接受安装，触发安装开始事件
      window.dispatchEvent(new CustomEvent("PWA_INSTALL_ACCEPTED"));
    } else {
      // 用户拒绝，触发安装被拒绝事件
      window.dispatchEvent(new CustomEvent("PWA_INSTALL_REJECTED"));
      const times = Number(utils.getObject("pwa-dismissed-times") || 0);
      utils.setObject("pwa-dismissed-times", times + 1);
    }
  });
};
window._getAssetUrl = (path: string) => {
  return config.getAssetUrl(path);
};
window._newAudio = (path: string) => {
  return new Audio((window as any)._getAssetUrl(path));
};

export default config;

const onOpenList: Record<string, (() => void) | null> = {
  onChangLongPage: null,
  onGameRecommendPopup: null,
  onFreeSpinPopup: null,
  onKYC_SettingPopup: null,
  onChatPopup: null,
  onProfilePopup: null,
};

const globalVars: Record<string, any> = {};
